import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=31af1a8d"
import script from "./SurveyList.vue?vue&type=script&lang=js"
export * from "./SurveyList.vue?vue&type=script&lang=js"
import style0 from "./SurveyList.vue?vue&type=style&index=0&id=31af1a8d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31af1a8d')) {
      api.createRecord('31af1a8d', component.options)
    } else {
      api.reload('31af1a8d', component.options)
    }
    module.hot.accept("./SurveyList.vue?vue&type=template&id=31af1a8d", function () {
      api.rerender('31af1a8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/SurveyList.vue"
export default component.exports